import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {

    createSubscriptionTicket: (ticket) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/create-subscription-ticket',
                    method: 'POST',
                    body: ticket,
                    types: [
                        types.CREATE_SUBSCRIPTION_TICKET_REQUEST,
                        types.CREATE_SUBSCRIPTION_TICKET_SUCCESS,
                        types.CREATE_SUBSCRIPTION_TICKET_FAILURE
                    ]
                }
            });
        },      
    updateTicket: (ticket) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/update',
                    method: 'PUT',
                    body: ticket,
                    types: [
                        types.UPDATE_SUPPORT_TICKET_REQUEST,
                        types.UPDATE_SUPPORT_TICKET_SUCCESS,
                        types.UPDATE_SUPPORT_TICKET_FAILURE
                    ]
                }
            });
        },
    loadTicket: (ticketId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/' + ticketId,
                    method: 'GET',
                    types: [
                        types.LOAD_TICKET_REQUEST,
                        types.LOAD_TICKET_SUCCESS,
                        types.LOAD_TICKET_FAILURE
                    ]
                }
            });
        },
    loadTicketFilters: () =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/index-filters',
                    method: 'POST',
                    types: [
                        types.LOAD_TICKET_FILTERS_REQUEST,
                        types.LOAD_TICKET_FILTERS_SUCCESS,
                        types.LOAD_TICKET_FILTERS_FAILURE
                    ]
                }
            });
        },
    searchTickets: (params) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/search',
                    method: 'POST',
                    body: params,
                    types: [
                        types.SEARCH_SUPPORT_TICKET_REQUEST,
                        types.SEARCH_SUPPORT_TICKET_SUCCESS,
                        types.SEARCH_SUPPORT_TICKET_FAILURE
                    ]
                }
            });
        },
    loadListFilters: (subId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/list-filters',
                    method: 'POST',
                    body: { subscriptionId: subId },
                    types: [
                        types.LOAD_SUPPORT_TICKET_FILTERS_REQUEST,
                        types.LOAD_SUPPORT_TICKET_FILTERS_SUCCESS,
                        types.LOAD_SUPPORT_TICKET_FILTERS_FAILURE
                    ]
                }
            });
        },
    updateAgent: (agentId, ticketId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/update-agent',
                    method: 'POST',
                    body: { agentId: agentId, ticketId: ticketId },
                    types: [
                        types.UPDATE_SUPPORT_TICKET_AGENT_REQUEST,
                        types.UPDATE_SUPPORT_TICKET_AGENT_SUCCESS,
                        types.UPDATE_SUPPORT_TICKET_AGENT_FAILURE
                    ]
                }
            });
        },
    loadTicketConversation: (ticketId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/load-conversation',
                    method: 'POST',
                    body: { ticketId: ticketId },
                    types: [
                        types.LOAD_TICKET_CONVERSATION_REQUEST,
                        types.LOAD_TICKET_CONVERSATION_SUCCESS,
                        types.LOAD_TICKET_CONVERSATION_FAILURE
                    ]
                }
            });
        },
    requestorReply: (ticketId, reply, isResolved) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/requestor-reply',
                    method: 'POST',
                    body: {
                        ticketId: ticketId,
                        reply: reply,
                        isResolved: isResolved
                    },
                    types: [
                        types.REQUESTOR_REPLY_SUPPORT_TICKET_REQUEST,
                        types.REQUESTOR_REPLY_SUPPORT_TICKET_SUCCESS,
                        types.REQUESTOR_REPLY_SUPPORT_TICKET_FAILURE
                    ]
                }
            });
        },
    giveFeedback: (rating, message, email, userKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'support/give-feedback',
                    method: 'POST',
                    body: {
                        rating: rating,
                        message: message,
                        email: email,
                        userKey: userKey
                    },
                    types: [
                        types.SUBMIT_FEEDBACK_REQUEST,
                        types.SUBMIT_FEEDBACK_SUCCESS,
                        types.SUBMIT_FEEDBACK_FAILURE
                    ]
                }
            });
        },        
}
